import React, { useEffect, useState } from "react";

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookiesAccepted");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="position-fixed bottom-0 w-100 text-dark p-3 shadow"
      style={{ backgroundColor: "rgb(255, 255, 255)", zIndex: 1050, borderTop: "1px solid rgb(59, 82, 89)" }}
    >
      <div className="container text-center d-flex flex-column flex-md-row justify-content-center align-items-center gap-2">
        <span>
          This website uses cookies to enhance the user experience.
        </span>
        <button
          className="btn"
          style={{
            backgroundColor: "rgb(59, 82, 89)",
            color: "#ffffff",
          }}
          onClick={handleAccept}
        >
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
